import css from '../../../utils/css';

const foxTheme: string = css`
  @font-face {
    font-family: FANtastic-FOX;
    src:
      url(https://statics.foxsports.com/static/orion/fonts/fs-FANtastic-FOX/FS-FANtastic-FOX.woff2)
        format('woff2'),
      url(https://statics.foxsports.com/static/orion/fonts/fs-FANtastic-FOX/FS-FANtastic-FOX.woff)
        format('woff'),
      url(https://statics.foxsports.com/static/orion/fonts/fs-FANtastic-FOX/FS-FANtastic-FOX.otf)
        format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: HaasGrotTextR-55Roman;
    src: url(https://statics.foxsports.com/static/orion/fonts/haas/HaasGrotTextR-55Roman.otf)
      format('opentype');
    font-display: swap;
  }

  @font-face {
    font-family: ProximaNova;
    src: url(https://statics.foxsports.com/static/orion/fonts/proxima-nova/ProximaNova-Regular.otf)
      format('opentype');
    font-display: swap;
  }

  [data-fpsm-theme] {
    --font-family-1: 'HaasGrotTextR-55Roman';
    --font-family-2: 'FANtastic-FOX';
    --font-family-3: 'ProximaNova';

    --fox-background: #000;
    --fox-black: #000;
    --fox-dark-blue: #0f2d37;
    --fox-almost-white: #f7f7f7;
    --fox-light-gray: #e5e5e5;
    --fox-nickel-gray: #7d7d7d;
    --fox-gray: #757575;
    --fox-blue: #0059b5;
    --fox-dark-blue: #01448a;
    --fox-white: #ffffff;
    --fox-disabled: #b2b2b2;

    --cxy-font-family-sans: var(--font-family-1), sans-serif;
    --widget-font-family: var(--font-family-1), sans-serif;

    --cxy-color-container-inverse: var(--fox-background);
    --cxy-color-surface-primary-default: var(--fox-background);
    --cxy-color-interactive-secondary: var(--fox-black);
    --cxy-color-interactive-senary: var(--fox-white);
    --cxy-color-interactive-senary-hover: var(--fox-light-gray);
    --cxy-color-content-prompt: var(--fox-white);
    --cxy-color-content-inverted: var(--fox-black);

    --cxy-color-container-light: var(--fox-light-gray);
    --cxy-color-container-subtle-brand: var(--fox-light-gray);
    --cxy-color-border-brand-deep: var(--fox-nickel-gray);
    --cxy-color-interactive-quinary: var(--fox-light-gray);
    --cxy-color-interactive-quinary-hover: var(--fox-gray);

    --cxy-color-interactive-tertiary: var(--fox-blue);

    --cxy-color-interactive-primary: var(--fox-blue);
    --cxy-color-interactive-primary-hover: var(--fox-dark-blue);
    --cxy-color-interactive-quaternary: var(--fox-blue);
    --cxy-color-interactive-quaternary-hover: var(--fox-dark-blue);
    --cxy-color-content-primary: var(--fox-white);
    --cxy-color-content-feature: var(--fox-black);

    --cxy-color-brand: var(--fox-blue);

    [class^='_eventWrapper'] {
      color: var(--fox-black);
    }

    [class*='_radioPickerButton'][class*='_isSelected'] {
      background-color: var(--fox-black);
      border-color: var(--fox-white);
      color: var(--fox-white);
    }

    [class*='_selectButton'][class*='_isSelected'] {
      background-color: var(--fox-white);
    }

    [data-testid='header']::before {
      content: url('data:image/svg+xml,%3Csvg%20width%3D%22183%22%20height%3D%2246%22%20viewBox%3D%220%200%20183%2046%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M36.3193%206.89279C34.8677%206.89279%2033.6949%208.20021%2033.6949%209.66144V22.4376C33.6949%2023.8989%2034.8677%2025.0909%2036.3193%2025.0909C37.771%2025.0909%2039.0688%2023.9469%2039.0688%2022.4761V9.66144C39.0688%208.20021%2037.771%206.89279%2036.3193%206.89279ZM36.2713%200.480669C44.856%200.480669%2051.8065%207.46959%2051.8065%2016.0736C51.8065%2024.6775%2044.8464%2031.6761%2036.2713%2031.6761C27.6961%2031.6761%2020.736%2024.6968%2020.736%2016.0736C20.736%207.45037%2027.6865%200.480669%2036.2713%200.480669ZM61.8621%206.94086L65.9381%200.0384535H75.7726L66.8514%2015.3814L76.6763%2032.0222H66.5149L61.7467%2023.9277L57.0265%2032.0318H47.144L56.7766%2015.4775L47.6823%200.0384535H57.8533L61.8621%206.94086ZM20.986%208.7674H9.9883V12.9492H18.948V21.707H9.93062V32.0702H0.749843V0H20.3804L20.986%208.77701V8.7674ZM43.8947%2039.2803H48.3264L48.7975%2038.8188V37.1076L48.3264%2036.6462H43.8947V39.2803ZM16.708%2039.934H21.1975L21.6782%2039.4629V37.2134L21.1975%2036.7327H16.708V39.934ZM29.9841%2037.4537V42.5873L30.6571%2043.241H34.4832L35.1657%2042.5873V37.4537L34.4832%2036.7904H30.6571L29.9841%2037.4537ZM76.1764%2036.0213L75.5035%2036.7039H68.7068L68.4472%2036.9634V38.6842L68.6395%2038.8669H75.0901L76.5225%2040.28V44.3753L74.869%2046H65.1595V44.3465L66.0247%2043.5294H72.9847L73.2443%2043.2698V41.5106L73.052%2041.3183H66.5919L65.1595%2039.9051V35.8675L66.813%2034.2428H76.186V36.0309L76.1764%2036.0213ZM64.0924%2036.9634H60.2951V46H57.0073V36.9634H53.2004V34.2428H64.102V36.9634H64.0924ZM52.0853%2035.8579V39.6071L50.5087%2041.1645L52.5852%2045.9904H48.9225L47.3747%2041.7317H43.8947V45.9904H40.6069V34.2332H50.4414L52.0949%2035.8579H52.0853ZM38.4535%2036.0502V44.1831L36.6077%2045.9904H28.5325L26.706%2044.1831V36.0502L28.5325%2034.2332H36.6077L38.4535%2036.0502ZM24.9852%2036.0502V40.405L23.1394%2042.2219H16.708V46H13.4107V34.2428H23.1394L24.9852%2036.0598V36.0502ZM11.0265%2036.0213L10.3536%2036.7039H3.54734L3.28777%2036.9634V38.6842L3.48004%2038.8669H9.93062L11.363%2040.28V44.3753L9.70951%2046H0V44.3465L0.865204%2043.5294H7.82529L8.08485%2043.2698V41.5106L7.89258%2041.3183H1.43239L0%2039.9051V35.8675L1.6535%2034.2428H11.0265V36.0309V36.0213Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M85.781%2020.015C82.8393%2020.015%2080.8974%2018.1019%2080.7339%2014.9391L80.6763%2013.9393H83.7814L83.8391%2014.8045C83.9737%2016.4004%2084.6754%2017.2367%2085.8675%2017.2367C87.0596%2017.2367%2087.5402%2016.5638%2087.5402%2015.2371C87.5402%2011.4591%2081.1954%2010.267%2081.1954%204.95084C81.1954%20-0.365359%2082.8873%200.0287894%2085.8579%200.0287894C88.8284%200.0287894%2090.3954%201.78804%2090.5877%204.7778L90.6453%205.40267H87.4825L87.4537%205.16233C87.3768%203.53767%2086.8096%202.81667%2085.8098%202.81667C84.81%202.81667%2084.4063%203.4127%2084.4063%204.4894C84.4063%208.26745%2090.7511%209.43067%2090.7511%2014.7757C90.7511%2020.1207%2088.8572%2020.015%2085.781%2020.015Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M91.5874%2019.7459L95.0963%200.298023H99.2781L102.787%2019.7459H99.605L98.932%2015.5064H95.3943L94.7502%2019.7459H91.5874ZM95.8269%2012.6993H98.4706L97.8457%208.86354C97.5189%207.05623%2097.2497%205.40273%2097.1728%204.46062H97.067C96.9901%205.40273%2096.7113%207.07545%2096.4229%208.80586L95.8269%2012.6993Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M109.814%2014.4489L108.19%209.31537C107.892%208.34442%20107.68%207.67148%20107.382%206.67169H107.276C107.334%207.43115%20107.469%2010.7766%20107.469%2012.6897V19.7363H104.421V0.298023H107.959L109.526%205.34505C110.016%206.85435%20110.42%208.2579%20110.526%208.71934H110.632C110.737%208.2579%20111.141%206.85435%20111.631%205.34505L113.198%200.298023H116.601V19.7459H113.496V12.6993C113.496%2010.7862%20113.631%207.43115%20113.689%206.6813H113.554C113.285%207.6811%20113.064%208.35403%20112.775%209.32498L111.151%2014.4585H109.824L109.814%2014.4489Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M127.801%200.298023V3.13397H122.696V8.23867H126.801V11.0458H122.696V16.9099H128.128V19.7459H119.457V0.298023H127.801Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M135.088%2013.8529V6.18141C135.088%202.01881%20136.79%200.0288448%20140.222%200.0288448C143.654%200.0288448%20145.269%201.83616%20145.269%205.50847V6.56594H142V5.86416C142%203.75883%20141.51%202.92247%20140.222%202.92247C138.933%202.92247%20138.357%203.78767%20138.357%205.86416V14.1797C138.357%2016.2851%20138.953%2017.1503%20140.385%2017.1503C141.817%2017.1503%20142.163%2016.3908%20142.163%2014.1797V12.6704H140.116V9.83449H145.278V14.074C145.278%2018.1212%20143.711%2020.0151%20140.279%2020.0151C136.847%2020.0151%20135.098%2018.0443%20135.098%2013.8625L135.088%2013.8529Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M146.374%2019.7459L149.893%200.298023H154.074L157.583%2019.7459H154.401L153.728%2015.5064H150.191L149.546%2019.7459H146.384H146.374ZM150.614%2012.6993H153.257L152.632%208.86354C152.305%207.05623%20152.036%205.40273%20151.959%204.46062H151.854C151.777%205.40273%20151.498%207.07545%20151.21%208.80586L150.614%2012.6993Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M164.601%2014.4489L162.976%209.31537C162.678%208.34442%20162.467%207.67148%20162.169%206.67169H162.063C162.121%207.43115%20162.255%2010.7766%20162.255%2012.6897V19.7363H159.208V0.298023H162.746L164.313%205.34505C164.803%206.85435%20165.207%208.2579%20165.312%208.71934H165.418C165.524%208.2579%20165.928%206.85435%20166.418%205.34505L167.985%200.298023H171.388V19.7459H168.283V12.6993C168.283%2010.7862%20168.418%207.43115%20168.475%206.6813H168.341C168.071%207.6811%20167.85%208.35403%20167.562%209.32498L165.937%2014.4585H164.611L164.601%2014.4489Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M182.588%200.298023V3.13397H177.483V8.23867H181.588V11.0458H177.483V16.9099H182.915V19.7459H174.243V0.298023H182.588Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M86.0789%2038.2805H84.7523V45.9519H81.5126V26.5041H86.0789C89.5878%2026.5041%2091.4528%2028.5037%2091.4528%2032.2529V32.5221C91.4528%2036.1175%2089.4532%2038.2709%2086.0789%2038.2709V38.2805ZM84.7523%2029.3112V35.4637H85.8578C87.4248%2035.4637%2088.1843%2034.5409%2088.1843%2032.6566V32.1183C88.1843%2030.2245%2087.4248%2029.3112%2085.8578%2029.3112H84.7523Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M91.2317%2045.9519L94.7406%2026.5041H98.9224L102.431%2045.9519H99.2492L98.5763%2041.7124H95.0386L94.3945%2045.9519H91.2317ZM95.4712%2038.9053H98.1149L97.49%2035.0696C97.1631%2033.2623%2096.894%2031.6088%2096.8171%2030.6667H96.7113C96.6344%2031.6088%2096.3556%2033.2815%2096.0672%2035.0119L95.4712%2038.9053Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M111.708%2037.0692L114.352%2045.9519H110.891L108.622%2037.819H107.296V45.9519H104.056V26.5041H108.565C112.16%2026.5041%20114.044%2028.3979%20114.044%2032.0414V32.2817C114.044%2034.5505%20113.208%2036.1944%20111.699%2037.0596L111.708%2037.0692ZM107.305%2029.3112V35.06H108.517C110.026%2035.06%20110.785%2034.2236%20110.785%2032.4163V31.9837C110.785%2030.1764%20110.026%2029.3112%20108.517%2029.3112H107.305Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M119.668%2026.5041V43.116H124.417V45.9519H116.419V26.5041H119.659H119.668Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M125.1%2045.9519L128.608%2026.5041H132.79L136.299%2045.9519H133.117L132.444%2041.7124H128.907L128.262%2045.9519H125.1ZM129.339%2038.9053H131.983L131.358%2035.0696C131.031%2033.2623%20130.762%2031.6088%20130.685%2030.6667H130.579C130.502%2031.6088%20130.224%2033.2815%20129.935%2035.0119L129.339%2038.9053Z%22%20fill%3D%22white%22%2F%3E%0A%3Cpath%20d%3D%22M138.895%2026.5041L139.952%2030.1476C140.385%2031.5223%20140.818%2033.2527%20141.087%2034.5505H141.192C141.462%2033.2527%20141.952%2031.5511%20142.404%2030.1476L143.509%2026.5041H146.614L142.673%2037.9825V45.9519H139.433V38.117L135.463%2026.5041H138.895Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E%0A');
      width: 183px;
    }

    [data-testid='header'] > img {
      display: none;
    }

    [data-testid='market-button'] {
      background-color: var(--fox-black);
      border: 1px solid var(--cxy-color-interactive-senary);
      color: var(--fox-white);
    }

    [class^='_clickOutWrapper'] svg,
    [data-testid='market-button'] svg {
      filter: invert(100%) brightness(200%) contrast(100%);
    }

    [class*='_betLegs'] {
      color: var(--fox-black);
    }

    [class*='_betLegs'] > [class*='_bestOdds'],
    [class*='_betLegs'] > [class*='_alert'],
    [data-testid='bet-item'],
    [data-testid='leg-name'] {
      color: var(--fox-black);
    }
    [class*='_prePopulated_'] [data-testid='leg-name'] {
      color: var(--fox-white);
    }

    [class^='_bulletCircleInner'] {
      background-color: var(--fox-white);
    }

    [class^='_bulletLine'],
    [class^='_bulletCircleOuter'] {
      background-color: var(--fox-gray);
    }

    [data-testid='leg-market'] {
      color: var(--fox-gray);
    }

    [class^='_bestOddsLabel'] {
      color: var(--fox-white);
    }

    [data-testid='multi-header'] {
      margin-top: 1.2em;
    }

    [class^='_subeventTeamsWrapper'] > [class^='_text'],
    [class^='_subeventTeamsWrapper'] > span {
      font-family: var(--font-family-2), sans-serif;
    }

    [class^='_editSelectionsButton'],
    [class^='_bestOddsSelection'] > button > span {
      font-family: var(--font-family-3), sans-serif;
      text-transform: uppercase;
    }

    [class*='_offersModal_'] {
      background-color: #f7f7f7;
      border-radius: 10px;
      overflow: hidden;
    }

    [class*='_offersModalHeader_'] {
      color: var(--fox-black);
    }

    [class*='_offersModalTitle_'] {
      color: inherit;
      font-family: var(--font-family-2);
    }

    [class*='_offersModal_'] [class*='_offer_'] button,
    [data-testid^='tab-button-'] {
      text-transform: capitalize;
    }

    [class*='_tabButtons_'] button {
      background-color: var(--fox-black);
      color: var(--fox-white);
    }

    [class*='_tabButtons_'] button[class*='_isInverted_'] {
      background-color: var(--fox-almost-white);
      color: var(--fox-black);
      border-color: var(--fox-black);
    }

    [class*='_offersModal_'] [data-testid^='offer-button-'] {
      border-radius: 21px;
    }

    [class*='_bestOddsLabel'],
    [class*='_isMarketSelectView'] > button,
    [class^='_addMarketSelect'] > button {
      text-transform: capitalize;
    }

    [class^='_clickOutWrapper'],
    [data-testid='bookie-price'] {
      color: var(--fox-white);
      background: var(--fox-blue);
    }

    [class^='_clickOutWrapper']:hover,
    [data-testid='bookie-price']:hover {
      background: var(--fox-dark-blue);
    }

    [data-testid='compare-odds'] {
      color: var(--fox-white);
    }

    [data-testid='compare-odds']:disabled {
      color: var(--fox-gray);
    }
  }
`;

export default foxTheme;
